/* eslint-disable import/prefer-default-export */
import styled from 'react-emotion';

export const Center = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
